export default "__VITE_ASSET__CWvUTyKL__"